import { buildReducer } from '../../utils/redux/getReduxModuleByFeatureName';
import getConstantsByFeatureName from '../../utils/redux/getConstantsByFeatureName';
import getActionCreators from '../../utils/redux/getActionCreators';
import getActionHandlers from '../../utils/redux/getActionHandlers';
import { initialState, addItemToData } from '../../utils/redux/commonActionHandlers';
import getSelectorByFeatureName from '../../utils/redux/getSelectorByFeatureName';

// CREW-1240 — the owner card's "Vacancy Contacts" tab.
export const constants = getConstantsByFeatureName('OWNER_VACANCY_CONTACTS');
export const actions = getActionCreators(constants);
export const reducer = buildReducer(initialState, {
  ...getActionHandlers(constants),
  [constants.ADD_CREATED_ITEM]: (state, action) => {
    const newState = addItemToData(state, action);

    return { ...newState, data: [...newState.data].sort((a, b) => String(a.name).localeCompare(String(b.name))) };
  },
});
export const selector = getSelectorByFeatureName('ownerDetailsVacancyContacts');
